# This is required to get around the popup blockers on mobile devices

@app.directive 'continueToCheckout', (ModalService, stripeService, authenticationService, $state)->
  restrict: 'E'
  scope: {}
  controller: ($scope) ->
    @checkout = ->
      checkoutParams = ModalService.modal.params.checkout
      sku = checkoutParams.sku
      isGift = checkoutParams.isGift
      user = $state.currentUser
      stripeService.showCheckout(sku, user, isGift)
      ModalService.resolve()

    this

  controllerAs: 'continueToCheckout'
  templateUrl: "/assets/templates/modals/continueToCheckout/continueToCheckout.html"
